import "./App.css";
import Banner from "./components/Banner";
import About from "./components/About";
import MyTasks from "./components/MyTasks";
import Portfolio from "./components/Portfolio";
import Skills from "./components/Skills";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";

function App() {
  return (
    <main>
      <Banner />
      <About />
      <MyTasks />
      <Portfolio />
      <Skills />
      <ContactUs />
      <Footer />
    </main>
  );
}

export default App;
